import {
  getDisciplineIcon
} from '../../../../utils/discipline';
import { Chip } from '../../../atoms/Chip';
import { Icon } from '../../../atoms/Icon';
import { ProgressBar } from '../../../atoms/ProgressBar';
import { Typography } from '../../../molecules/Typography';
import { useScheduleSlotContext } from '../useScheduleSlotContext';

interface IScheduleSlotCompactProps {
  type: 'discipline' | 'simulated' | 'essay';
  title?: string;
}

export function ScheduleSlotCompact({
  type,
  title,
}: IScheduleSlotCompactProps) {
  const { disciplineSlug, selected, currentProgress, totalProgress } =
    useScheduleSlotContext();
  const disciplineIcon = getDisciplineIcon(disciplineSlug);

  function getProgressPercentage() {
    return (currentProgress / totalProgress) * 100;
  }

  const isCompleted = currentProgress === totalProgress;

  if (type === 'discipline') {
    return (
      <>
        <Icon
          type={'svg'}
          Icon={disciplineIcon}
          className={`w-6 text-disciplina-${disciplineSlug} ${selected ? 'text-mono-color-white' : ''}`}
        />
        <Typography 
          size={'small'} 
          className={`text-disciplina-${disciplineSlug} ${selected ? 'text-mono-color-white' : ''}`}
        >
          {title}
        </Typography>
        {isCompleted ? (
          <Chip
            size={'sm'}
            className={'border-none bg-feedback-color-success-pure'}
          >
            Concluído
          </Chip>
        ) : (
          <ProgressBar
            color={
              selected ? 'mono-color-white' : `disciplina-${disciplineSlug}`
            }
            backgroundColor={
              selected ? 'mono-color-medium' : 'mono-color-white'
            }
            progress={getProgressPercentage()}
          />
        )}  
      </>
    );
  }

  if (type === 'simulated') {
    return (
      <div className='flex items-center justify-between gap-lg'>
        <Typography size={'small'}>{title}</Typography>
        {isCompleted ? (
          <Chip
            size={'sm'}
            className={'border-none bg-feedback-color-success-pure'}
          >
            Concluído
          </Chip>
        ) : (
          <Chip size={'sm'} variant={'negative'}>
            Simulado
          </Chip>
        )}
      </div>
    );
  }

  if (type === 'essay') {
    return (
      <div className='flex items-center justify-between gap-lg'>
        <ProgressBar
          color={
            selected ? 'mono-color-white' : `disciplina-${disciplineSlug}`
          }
          backgroundColor={
            selected ? 'mono-color-medium' : 'mono-color-white'
          }
          progress={getProgressPercentage()}
        />
        {isCompleted && (
          <Chip
            size={'sm'}
            className={'border-none bg-feedback-color-success-pure'}
          >
            Concluído
          </Chip>
        )}
      </div>
    );
  }

  return <></>;
}
